// Sidebar navigation — grouped like the new design.
// `match` lists every route prefix that should highlight the item.
import { TICKETS } from '../../utils/staticData';

export interface NavItem {
  path: string;
  label: string;
  icon: string;
  match: string[];
  count?: number;
}

export const NAV: [string, NavItem[]][] = [
  ['Overview', [
    { path: '/dashboard', label: 'Dashboard', icon: 'ri-dashboard-3-line', match: ['/dashboard'] },
  ]],
  ['Customers', [
    { path: '/customers-and-users', label: 'Customers', icon: 'ri-building-2-line', match: ['/customers-and-users', '/users'] },
    { path: '/whatsapp-numbers', label: 'WhatsApp numbers', icon: 'ri-whatsapp-line', match: ['/whatsapp-numbers'] },
  ]],
  ['Revenue', [
    { path: '/plans-pricing', label: 'Plan & Pricing', icon: 'ri-price-tag-3-line', match: ['/plans-pricing', '/plan-', '/add-plan'] },
    { path: '/subscription', label: 'Subscriptions', icon: 'ri-refresh-line', match: ['/subscription', '/billing-subscription'] },
    { path: '/invoices', label: 'Invoices', icon: 'ri-file-list-3-line', match: ['/invoices'] },
    { path: '/wallet', label: 'Wallet', icon: 'ri-wallet-3-line', match: ['/wallet'] },
  ]],
  ['Partners', [
    { path: '/white-label', label: 'White-label', icon: 'ri-palette-line', match: ['/white-label'] },
    { path: '/affiliate-program/account', label: 'Affiliates', icon: 'ri-share-forward-line', match: ['/affiliate-program', '/affiliate-details'] },
  ]],
  ['Operations', [
    { path: '/tickets', label: 'Tickets', icon: 'ri-customer-service-2-line', match: ['/tickets'], count: TICKETS.filter(t => t.st === 'open').length },
    { path: '/system-health', label: 'System health', icon: 'ri-pulse-line', match: ['/system-health'] },
    { path: '/feature-flags', label: 'Feature flags', icon: 'ri-toggle-line', match: ['/feature-flags'] },
  ]],
  ['Governance', [
    { path: '/admin-team', label: 'Admin & roles', icon: 'ri-shield-user-line', match: ['/admin-team'] },
    { path: '/audit-log', label: 'Audit log', icon: 'ri-history-line', match: ['/audit-log'] },
  ]],
  ['Resources', [
    { path: '/knowledge-base', label: 'Knowledge base', icon: 'ri-book-open-line', match: ['/knowledge-base', '/add-knowledge-category'] },
  ]],
];

export const NAV_ITEMS: NavItem[] = NAV.flatMap(([, items]) => items);

export const isNavActive = (item: NavItem, pathname: string) =>
  item.match.some(m => pathname === m || pathname.startsWith(m.endsWith('-') ? m : m + '/') || pathname.startsWith(m + '-'));
